import * as _ from 'lodash';

const search_type = {
	vehicle: 'vehicle',
	user: 'employee',
	driver: 'driver',
	location: 'location',
	pin_code: 'pin_code',
};

const UserTypesOptions = [
	{ value: '', label: 'All' },
	{ value: 'admin', label: 'Admin' },
	{ value: 'supervisor', label: 'Supervisor' },
	{ value: 'city_manager', label: 'City Manager' },
	{ value: 'management', label: 'Management' },
	{ value: 'control_tower', label: 'Control Tower' },
];
const empUserTypesOptions = [
	{ value: 'admin', label: 'Admin' },
	{ value: 'supervisor', label: 'Supervisor' },
	{ value: 'business', label: 'Business' },
	{ value: 'city_manager', label: 'City Manager' },
	{ value: 'management', label: 'Management' },
	{ value: 'control_tower', label: 'Control Tower' },
	{ value: 'finance', label: 'Finance' },
	{ value: 'mis_executive', label: 'MIS Executive' },
];

const legal_structure_data = [
	{ value: 'company', label: 'Company' },
	{ value: 'LLP', label: 'LLP' },
	{ value: 'individual', label: 'Individual' },
];

const gstRegType = [
	{ value: 'unregistered', label: 'Unregistered' },
	{ value: 'registered', label: 'Registered' },
];

const TripTypesOptions = [
	{ value: 'regular', label: 'Regular' },
	{ value: 'adhoc', label: 'Adhoc' },
	// { value: 'replacement', label: 'Replacement' },
];
const intercityData = [
	{ value: false, label: 'NO' },
	{ value: true, label: 'YES' },
];

const vendorUserType = [
	{ value: 'regular', label: 'Regular' },
	{ value: 'temporary', label: 'Temporary' },
];

const gender_list_data = [
	{ value: 'male', label: 'MALE' },
	{ value: 'female', label: 'FEMALE' },
	{ value: 'others', label: 'OTHERS' },
];

const contractOptions = [
	{ value: 'shippment', label: 'shippment' },
	{ value: 'km_based', label: 'KM basesd' },
];

const FileTypesOptions = [
	{ value: 'trip_history', label: 'Trip History' },
	{ value: 'vendor_master_reports', label: 'Vendor Master reports' },
	// { value: 'replacement', label: 'Replacement' },
];

const day_wise_options = [
	{
		label: 'Sunday',
		value: 'sunday',
	},
	{
		label: 'Monday',
		value: 'monday',
	},
	{
		label: 'Tuesday',
		value: 'tuesday',
	},
	{
		label: 'Wednesday',
		value: 'wednesday',
	},
	{
		label: 'Thursday',
		value: 'thursday',
	},
	{
		label: 'Friday',
		value: 'friday',
	},
	{
		label: 'Saturday',
		value: 'saturday',
	},
];

const primary_cost_data = [
	{ value: 'logistics', label: 'LOGISTICS' },
	{ value: 'distribution', label: 'DISTRIBUTION' },
];
const adhoc_approval_required_data = [
	{ value: 'true', label: 'Yes' },
	{ value: 'false', label: 'No' },
];

const reportingTimeOptions = [
	{ value: '24 Hrs', label: '24 Hrs' },
	{ value: 'shift', label: 'Shift' },
];

const vehicleTypeOptions = [
	{ value: '2 wheeler', label: '2 wheeler' },
	{ value: '3 wheeler', label: '3 wheeler' },
	{ value: '4 wheeler', label: '4 wheeler' },
];

const fuelTypeOptions = [
	{ value: 'Petrol', label: 'Petrol' },
	{ value: 'Diesel', label: 'Diesel' },
	{ value: 'Electric', label: 'Electric' },
];

const driveModeOptions = [
	{ value: 'Manual', label: 'Manual' },
	{ value: 'Automatic', label: 'Automatic' },
	{ value: 'Automatic + Manual', label: 'Automatic + Manual' },
];

const defaultMonth_wiseData = {
	sunday: false,
	monday: false,
	tuesday: false,
	wednesday: false,
	thursday: false,
	friday: false,
	saturday: false,
};

const manufactureString =
	'Atul Auto, Ather Energy, Hero Electric, Lohia Auto, Mahindra Electric, Okinawa, Ola Electric, Volvo, Bajaj, MAN SE, Maruti, Tata Motors, Bharat Benz, Force Motors, Swaraj Mazda, Eicher Motors, Ashoka Layland, Hindustan Motors, Mahindra & Mahindra, Hero, Honda, ALTIGREEN, Piaggio, YAMAHA';
const manufacturesArray = manufactureString.split(', ');

const makersOptions = manufacturesArray.map((item) => ({
	value: item,
	label: item,
}));

const sortedmakersOptions = _.sortBy(makersOptions, 'value');
// console.log(makersOptions);

const makerOptions = [
	{ value: 'Volvo', label: 'Volvo' },
	{ value: 'Bajaj', label: 'Bajaj' },
	{ value: 'MAN SE', label: 'MAN SE' },
	{ value: 'Maruti', label: 'Maruti' },
	{ value: 'Tata Motors', label: 'Tata Motors' },
	{ value: 'Bharat Benz', label: 'Bharat Benz' },
	{ value: 'Force Motors', label: 'Force Motors' },
	{ value: 'Swaraj Mazda', label: 'Swaraj Mazda' },
	{ value: 'Eicher Motors', label: 'Eicher Motors' },
	{ value: 'Ashoka Layland', label: 'Ashoka Layland' },
	{ value: 'Hindustan Motors', label: 'Hindustan Motors' },
	{ value: 'Mahindra & Mahindra', label: 'Mahindra & Mahindra' },
];
const mobileError = 'Must be exactly 10 digits';
const pinError = 'Must be exactly 6 digits';

const DATE_FORMAT_WITH_TIME = 'MM/DD/YYYY HH:mm';
const DATE_FORMAT = 'MM/DD/YYYY';
const DAY_DATE_FORMAT = 'DD/MM/YYYY';
const TIME_FORMAT = 'HH:mm';
const TIME_FORMAT_AM_PM = 'hh:mm a';

const pdfimgformates = ['application/pdf', 'image/png', 'image/jpeg'];
const pdfimgfiletypetoShow = 'PDF , PNG ,  JPEG ';

const docimgpdffiletypetoShow = 'PDF , DOC ,  JPEG ';
const docimgpdffileformates = [
	'application/pdf',
	'application/msword',
	'.doc',
	'.docx',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export {
	vehicleTypeOptions,
	fuelTypeOptions,
	driveModeOptions,
	makerOptions,
	day_wise_options,
	search_type,
	UserTypesOptions,
	legal_structure_data,
	gstRegType,
	empUserTypesOptions,
	TripTypesOptions,
	intercityData,
	pdfimgformates,
	pdfimgfiletypetoShow,
	vendorUserType,
	DATE_FORMAT,
	DATE_FORMAT_WITH_TIME,
	TIME_FORMAT,
	gender_list_data,
	docimgpdffiletypetoShow,
	docimgpdffileformates,
	contractOptions,
	primary_cost_data,
	mobileError,
	pinError,
	reportingTimeOptions,
	TIME_FORMAT_AM_PM,
	DAY_DATE_FORMAT,
	sortedmakersOptions,
	defaultMonth_wiseData,
	adhoc_approval_required_data,
	FileTypesOptions,
};
